interface PersonInsideChipSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonInsideChipSVG = ({ color, style }: PersonInsideChipSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="52"
    viewBox="0 0 34 52"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12464)">
      <path
        d="M28.9742 40.9433H4.30749C2.98783 40.9433 1.91992 39.8509 1.91992 38.5057V13.3225C1.91992 11.9752 2.98992 10.8849 4.30749 10.8849H28.9742C30.2939 10.8849 31.3618 11.9773 31.3618 13.3225V38.5057C31.3618 39.853 30.2918 40.9433 28.9742 40.9433Z"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.95534 10.8849V1.15604H0.521973"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6396 10.8849V1.15604"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3569 10.8849V1.15604"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3228 40.9433V50.6722H32.7561"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6396 40.9433V50.6722"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.92139 40.9433V50.6722"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1678 29.7836C16.8665 29.7836 17.4308 29.2052 17.4308 28.4941C17.4308 27.783 16.8644 27.2046 16.1678 27.2046C15.4713 27.2046 14.9048 27.783 14.9048 28.4941C14.9048 29.2052 15.4713 29.7836 16.1678 29.7836Z"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1678 22.0446C16.8665 22.0446 17.4308 21.4663 17.4308 20.7551C17.4308 20.044 16.8644 19.4657 16.1678 19.4657C15.4713 19.4657 14.9048 20.044 14.9048 20.7551C14.9048 21.4663 15.4713 22.0446 16.1678 22.0446Z"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9569 25.9152C20.6534 25.9152 21.2199 25.3368 21.2199 24.6257C21.2199 23.9145 20.6534 23.3362 19.9569 23.3362C19.2603 23.3362 18.6938 23.9145 18.6938 24.6257C18.6938 25.3368 19.2603 25.9152 19.9569 25.9152Z"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35205 27.2046H11.7446L13.0076 28.4941H14.9021"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35205 22.0446H11.7446L13.0076 20.7551H14.9021"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6934 24.6236H7.95557"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9519 31.0966C9.12452 29.5587 7.95801 27.2303 7.95801 24.6236C7.95801 19.9969 11.638 16.2399 16.1697 16.2399C20.7015 16.2399 24.3815 19.9969 24.3815 24.6236L26.276 27.2025L24.3815 28.492L23.1185 33.6499L18.6958 33.0051L18.0643 35.5841H9.85254L10.9519 31.0945V31.0966Z"
        stroke={color}
        strokeWidth="1.17381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12464">
        <rect width="34" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonInsideChipSVG;
